import Types from "./Types";

const INIT_STATE = {
  bookings: [],
  booking: {},
  count: 0,
  load: null,
  error: null,
};

export function bookingsReducer(state = INIT_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.BOOKINGS_LOADING: {
      return {
        ...state,
        load: payload,
      };
    }
    case Types.GET_BOOKINGS_SUCCESS: {
      return {
        ...state,
        bookings: payload?.data?.bookings || [],
        count: payload?.extra?.total_count,
      };
    }
    case Types.GET_BOOKING_DETAILS_SUCCESS: {
      return {
        ...state,
        booking: payload?.data?.booking || {},
      };
    }
    default:
      return state;
  }
}
